// #SAFETY_PRIVATE_V1 (2026-10-14) — Bill: the 'safety-files' bucket was PUBLIC, so anyone holding a link
// could open damage video, injury photos and claim documents without signing in. It is now private and
// every read goes through a short-lived SIGNED link made with the viewer's own DOPE sign-in (storage RLS
// = Safety access for report evidence; any signed-in user for msds/ and doclib/). HR (emp-files) and the
// Daily Log (log-files) already sign the same way, so the old "signing was blocked" problem is gone.
export const SAFETY_BUCKET = 'safety-files';
const _cache = new Map();   // path|expiry|download -> { url, exp } — one signing call per file per hour, not per render

export function makeSafetySigner(supaUrl, supaKey, getToken) {
  return async function signSafety(path, expiresIn = 3600, download) {
    if (!path || !supaUrl) return '';
    const k = `${path}|${expiresIn}|${download || ''}`;
    const hit = _cache.get(k);
    if (hit && hit.exp > Date.now() + 60000) return hit.url;
    try {
      const tok = getToken ? await getToken() : null;
      const res = await fetch(`${supaUrl}/storage/v1/object/sign/${SAFETY_BUCKET}/${path}`, {
        method: 'POST',
        headers: { apikey: supaKey, Authorization: `Bearer ${tok || supaKey}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ expiresIn }),
      });
      const d = await res.json();
      if (!d || !d.signedURL) return '';
      let url = `${supaUrl}/storage/v1${d.signedURL}`;
      if (download) url += `&download=${encodeURIComponent(download)}`;
      _cache.set(k, { url, exp: Date.now() + expiresIn * 1000 });
      return url;
    } catch { return ''; }
  };
}

// Open a private file in a new tab. The tab is opened FIRST (inside the tap) so phones don't block it as a
// pop-up, then pointed at the signed link once it comes back.
export async function openSafetyFile(signSafety, path, download) {
  const w = download ? null : window.open('', '_blank');
  const u = await signSafety(path, 3600, download);
  if (!u) {
    if (w) w.close();
    alert('Could not open that file. Your sign-in may have expired, or your role does not have Safety access.\n\nReload the page (Ctrl+Shift+R) and try again.');
    return;
  }
  if (w) w.location.href = u; else window.location.href = u;
}
